// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlockClickTooltip {
  display: inline-flex;
  cursor: pointer;
}
.BlockClickTooltip.tooltipped-multiline::after {
  width: 160px;
}`, "",{"version":3,"sources":["webpack://./src/components/BlockClickTooltipped/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,eAAA;AACF;AACE;EACE,YAAA;AACJ","sourcesContent":[".BlockClickTooltip {\n  display: inline-flex;\n  cursor: pointer;\n\n  &.tooltipped-multiline::after {\n    width: 160px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
